'use client';

import { Box, Heading, KeyValueTable } from '@petsmart-ui/sparky';

import { orderSummaryRows } from './constants';
import { EarnedPoints } from './EarnedPoints';
import { KeyValueRow } from './KeyValueRow';
import type { PaymentMethodPreviewProps } from './PaymentMethodPreview';
import { PaymentMethodPreview } from './PaymentMethodPreview';
import type { OrderSummaryRow } from './types';

export interface OrderSummaryViewProps {
    title?: string;
    earnedPoints?: number;
    paymentMethod?: PaymentMethodPreviewProps['paymentMethod'];
    rows: OrderSummaryRow[];
    futurePromisedShipDate?: string;
    promisedShipDate?: string;
}

export function OrderSummaryView({
    rows,
    title,
    earnedPoints,
    paymentMethod,
    futurePromisedShipDate,
    promisedShipDate,
}: Readonly<OrderSummaryViewProps>) {
    return (
        <Box className="order-summary">
            <Heading tagName="h2" size="headline" className="sparky-u-margin-bottom-md">
                {title ?? (futurePromisedShipDate ? 'Autoship enrollment summary' : 'Order summary')}
            </Heading>
            <KeyValueTable fullWidth className="sparky-u-margin-bottom-sm">
                {rows.map((row, index) => (
                    <KeyValueRow {...orderSummaryRows[row.key]?.getProps(row)} key={`${row.key}_${String(index)}`} />
                ))}
            </KeyValueTable>
            {earnedPoints !== undefined && <EarnedPoints points={earnedPoints} />}
            {paymentMethod && (
                <PaymentMethodPreview paymentMethod={paymentMethod} promisedShipDate={promisedShipDate} />
            )}
        </Box>
    );
}
